import { useQuery } from '@tanstack/react-query'
import { getUsersCount } from '../services/streamingService'

export const useUsersCount = ({ refetchInterval, eventId, enabled }) => {
  const {
    data = {},
    status,
    isLoading,
  } = useQuery({
    queryKey: ['event-users-count', eventId],
    queryFn: () => getUsersCount(eventId),
    enabled,
    refetchInterval: refetchInterval,
    refetchOnMount: false,
    refetchOnReconnect: !!refetchInterval,
    refetchOnWindowFocus: false,
  })

  return { usersCount: data.count ?? 0, status, isLoading: enabled ? isLoading : false }
}
